import React from "react";

import { getIcon } from "../../../helpers/icons";
import Link from "../../../components/Link";

import style from "./style.module.css";

export default function SocialMedia({ item = [] }) {
    return (
        <>
            {
                item.length > 0 && (
                    <div className={style.socialMedia}>
                        {
                            item.map((socialmediaMenu, socialmediaIndex) => {
                                let icon = socialmediaMenu.label ? getIcon(socialmediaMenu.label) : '';
                                return (
                                    <Link
                                        key={`socialmediaIndex_${socialmediaIndex}`}
                                        to={socialmediaMenu.link}
                                        className={style.socialmediaItem}
                                    >
                                        {<i className={icon}></i>}
                                    </Link>
                                )
                            })
                        }
                    </div>
                )
            }
        </>
    )
}